<div class="ui-file-loader">
  <ng-content></ng-content>
  <input #inputEl
    class="ui-file-loader__input" 
    type="file"
    [multiple]="multiple"
    (change)="inputChangeHandler($event)"/>
</div>
